import {ChangeDetectionStrategy, Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthService} from '../security/auth.service';
import {UserService} from "../services/user.service";
import {LocalStorageService} from "../services/local-storage.service";
import {
  AGENCY_PATH, AllExceptPatientAllowedRoles, EDOCS, IOH_USER_PATH,
  OnlyAdminAllowedRoles, OnlyAdminAndCompanyAdminAllowedRoles, OnlyAllowedExceptClinicianRoles,
  OnlyCaseManagerClinicianAllowedRoles,
  OnlyClinicianAllowedRoles,
  OnlySuperAdminAllowedRoles, PATH_BEFORE_REFRESH,
  RoleID,
  SUBMISSION_PATH,
  USER_PROFILE, USERS_PATH, VISIT_PATH, FORCE_RESET_PASSWORD_PATH, TWOFA_VERIFICATION_PATH,
  CHANGE_USER_PASSWORD_DAYS,
  CHANGE_USER_PASSWORD_BANNER_SHOW_DAYS, TOTP_SETUP_PATH, OnlyIOHSuperAdminAllowedRoles, superAndCaseMangerRoles
} from "../common/Constants";
import {Subscription, take} from "rxjs";
import {SidenavService} from "../core/sidebar/sidenav.service";
import {SidenavItem} from "../core/sidebar/sidenav-item.interface";
import {UserDataManager} from "../user/UserDataManager";
import {Location} from '@angular/common';
import { AgencyService } from '../services/agency/agency.service';
import { CompanyService } from '../services/company/company.service';
import {User} from "../models/user";
import {MessageHandlerService} from "../services/message-handler.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, OnDestroy {
  toggleSidebar = true;
  subscriptions: Subscription[] = [];
  userSubscription: Subscription;
  isEDocPurchased: boolean = false;
  /**
   * IOHB-NA: Quality Assurance feature visibility flag.
   * Read from `Agency.portalFeatures.qaScrubberEnabled` on the agency the
   * current user is acting under, mirroring the existing `isEDocPurchased`
   * pattern. The QA menu item and route are hidden when this is false.
   */
  isQaScrubberEnabled: boolean = false;
  isQAScrubberV4Enabled: boolean = false;
  /** Set only for company admin via /company/isIOInsightEnabled; used for IO Insights menu and redirect. */
  isIOInsightEnabledForCompanyAdmin: boolean = false;
  currentRole: string;
  navigateTo : string = AGENCY_PATH;
  currentAgencyId: string;
  currentUser : User;
  messageCount = 0
  days = 0
  RESTRICTED_ROLES = [RoleID.OfficeWorker.toString(), RoleID.Clinician.toString()]
  constructor(private router : Router , private authService : AuthService, private userService: UserService,
              private userDataManager: UserDataManager,
              private localStorageService: LocalStorageService,
              private location: Location,
              private sideNavService: SidenavService,
              private agencyService: AgencyService,
              private companyService: CompanyService,
              private messageHandlerService: MessageHandlerService) {

  }

  ngOnInit(): void {
    this.addEDocItemsToMenu();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  async getUserProfile() {
    try {
       this.subscriptions.push(this.userDataManager.user$.subscribe(res => {
       if (res) {
        this.currentUser = res;

        const days = this.calculateDays(res.changePassword ?? res.createdAt)
        if (days >= CHANGE_USER_PASSWORD_BANNER_SHOW_DAYS && days <= CHANGE_USER_PASSWORD_DAYS  && !this.RESTRICTED_ROLES.includes(this.currentRole) && this.currentRole !== "" && this.messageCount === 0) {
          this.messageCount += 1
          this.days = 60 - days
        }
        if (days >= CHANGE_USER_PASSWORD_DAYS && !this.RESTRICTED_ROLES.includes(this.currentRole) && this.currentRole !== "") {
          this.router.navigate([FORCE_RESET_PASSWORD_PATH]);
          return
        }

        if(res.userSettings?.mfa_token && !res?.totp_secret){
          this.router.navigate([TOTP_SETUP_PATH]);
          return;
        }


        // if (!this.localStorageService.get('2fa_verified') && res.userSettings.mfa_token && res.userSettings.mfa_verified) {
        //   this.router.navigate([TWOFA_VERIFICATION_PATH], { queryParams: { onlyVerify: true } });
        //   return
        // }

        this.localStorageService.set(PATH_BEFORE_REFRESH, this.location.path());
        const path = this.localStorageService.get(PATH_BEFORE_REFRESH);
        const companyAdminRole =
          res.currentUserRole === RoleID.companyAdmin ||
          this.currentRole === RoleID.companyAdmin;
        if (
          res?.is_company_admin &&
          companyAdminRole &&
          this.isIOInsightEnabledForCompanyAdmin &&
          this.isDefaultDashboardLanding(path)
        ) {
          this.router.navigate(['/io-insight']);
          if (path) {
            this.localStorageService.remove(PATH_BEFORE_REFRESH);
          }
          this.localStorageService.set(USER_PROFILE, res?.toString());
          return;
        }
         if(this.currentRole === RoleID.AgencyAdmin && this.isEDocPurchased && (!path || this.router.url === '/')){
           this.router.navigate([AGENCY_PATH]);
         }else if(this.currentRole  && (this.currentRole === RoleID.AgencyAdmin)
           && !this.isEDocPurchased && this.router.url === EDOCS){
           this.router.navigate([AGENCY_PATH]);
        }else if(res?.is_super_admin && (!path || this.router.url === '/')){
           this.router.navigate(['/dashboard']);
        }else if(this.currentRole === RoleID.AgencyAdmin && this.isDefaultDashboardLanding(path)){
           this.router.navigate([AGENCY_PATH]);
        }else if(res?.is_company_admin && !this.isIOInsightEnabledForCompanyAdmin && this.isDefaultDashboardLanding(path)){
           this.router.navigate([AGENCY_PATH]);
        }else if((res?.defaultRole === RoleID.Clinician ||  res?.defaultRole === RoleID.CaseManager || res?.defaultRole === RoleID.OfficeWorker)
          && !this.isEDocPurchased && this.router.url === EDOCS){
          this.router.navigate([SUBMISSION_PATH])
        } else if((this.currentRole === RoleID.Clinician || this.currentRole === RoleID.CaseManager ||
           this.currentRole === RoleID.OfficeWorker) && this.router.url == AGENCY_PATH) {
           this.router.navigate([VISIT_PATH]);
         } else if ((res?.defaultRole === RoleID.Clinician ||
            res?.defaultRole === RoleID.CaseManager || res?.defaultRole === RoleID.OfficeWorker)
          && !this.localStorageService.get('currentRole')) {
          this.router.navigate([SUBMISSION_PATH])
        }else if(res?.defaultRole === RoleID.AgencyAdmin || res?.defaultRole === RoleID.CaseManager || res?.defaultRole === RoleID.OfficeWorker){
          this.router.navigate([AGENCY_PATH]);
        }else if(res?.defaultRole === RoleID.Clinician && (path === IOH_USER_PATH || path === USERS_PATH)){
          this.router.navigate([SUBMISSION_PATH]);
        }else{
           if(res?.is_company_admin && !this.isEDocPurchased && this.router.url === EDOCS){
              this.router.navigate([AGENCY_PATH]);
           }
           if(res?.is_IOH_admin && this.router.url === '/'){
              this.router.navigate([AGENCY_PATH]);
           }

         }
        // if ((res?.content?.data?.is_super_admin || res?.content?.data?.is_IOH_admin || res?.content?.data?.defaultRole === RoleID.AgencyAdmin) && (!path || this.router.url === '/')) {
        //   this.router.navigate([AGENCY_PATH])
        // } else if ((res?.content?.data?.defaultRole === RoleID.Clinician ||
        //     res?.content?.data?.defaultRole === RoleID.CaseManager || res?.content?.data?.defaultRole === RoleID.OfficeWorker)
        //   && !this.localStorageService.get('currentRole')) {
        //   this.router.navigate([SUBMISSION_PATH])
        // }
        if (path) {
          this.localStorageService.remove(PATH_BEFORE_REFRESH);
        }
        this.localStorageService.set(USER_PROFILE, res?.toString());
      }
    }));
    }catch (e) {
      console.log(e);
    }


  }

  calculateDays(date: Date) {
    const createdAt_or_passwordChange = new Date(date);
    const currentDate = new Date();

    //calculate time difference
    const time_difference = currentDate.getTime() - createdAt_or_passwordChange.getTime();

    //calculate days difference by dividing total milliseconds in a day
    const days_difference = time_difference / (1000 * 60 * 60 * 24);

    return Math.floor(days_difference)
  }

  getUserRole() {
    this.subscriptions.push(this.userService.getUserRole().subscribe(res => {
      if(res?.success) {
        this.localStorageService.set('role', res?.content?.data?.role);
      }
    }));
  }

  getCurrentAgencyRole() {
    //this.subscriptions.push(this.userDataManager.activeAgencyRole$.subscribe((currentRole) => {
      // this.currentUser = currentRole
      //this.getAgencies(currentRole.agency)
      // if(currentRole.role !==RoleID.Admin){
      //   this.items$ = this.items$.filter(
      //     item =>(!this.isEDocPurchased && this.currentUser.role as RoleID === this.superAdmin) || ((item.name === 'Agencies' || item.name === 'eDoc') && this.isEDocPurchased) || (item.name !== 'Agencies' && item.name !== 'eDoc')
      //   )
      // }


   // }));
  }

  addFeatureItemsToMenu(menu: SidenavItem[],Navigation) {
    menu.push(Navigation);
  }

  addEDocItemsToMenu() {
    try {
     this.subscriptions.push(this.userDataManager.activeAgencyRole$.subscribe((currentRole) => {
       if(OnlyAllowedExceptClinicianRoles.includes(currentRole.role)) {
         let request = {
           agencyId: currentRole.agency
         };
         const finishEdocAndMenu = (res: any) => {
           if (res?.success && res.content?.data) {
             this.isEDocPurchased = res.content?.data?.portalFeatures?.eDoc
             // IOHB-NA: read the QA Scrubber flag from the same agency
             // portalFeatures map. Strict === true so missing / falsy values
             // (undefined, 'true' string, 1, etc.) all resolve to disabled.
             this.isQaScrubberEnabled =
               res.content?.data?.portalFeatures?.qaScrubberEnabled;
             this.isQAScrubberV4Enabled = res.content?.data?.portalFeatures?.qaScrubberV4Enabled;
           }
           this.currentRole = currentRole.role;
           this.createMenu();
           this.getUserProfile();
         };

         if (currentRole.role === RoleID.companyAdmin) {
           this.subscriptions.push(
             this.companyService.checkIsIOInsightEnabled().subscribe({
               next: (ioRes) => {
                 this.isIOInsightEnabledForCompanyAdmin = this.parseIoInsightEnabledResponse(ioRes);
                 this.subscriptions.push(
                   this.agencyService.checkIfeDocEnabled(request).subscribe(finishEdocAndMenu)
                 );
               },
               error: () => {
                 this.isIOInsightEnabledForCompanyAdmin = false;
                 this.subscriptions.push(
                   this.agencyService.checkIfeDocEnabled(request).subscribe(finishEdocAndMenu)
                 );
               }
             })
           );
         } else {
           this.isIOInsightEnabledForCompanyAdmin = false;
           this.subscriptions.push(
             this.agencyService.checkIfeDocEnabled(request).subscribe(finishEdocAndMenu)
           );
         }


       }else{
          if (!currentRole.role) {
            return;
          }
          this.currentRole = currentRole.role;
          this.isIOInsightEnabledForCompanyAdmin = false;
          this.createMenu();
          this.getUserProfile();
       }
    }));

     }catch (error) {
    }


  }

  /** True for “default” shell routes where we auto-redirect after login (path may be from storage). */
  private isDefaultDashboardLanding(path: string | null): boolean {
    const url = this.router.url || '';
    return (
      !path ||
      url === '/' ||
      url === '' ||
      url === '/agencies'
    );
  }

  private parseIoInsightEnabledResponse(res: any): boolean {
    if (res?.success === false) {
      return false;
    }
    const d = res?.content?.data;
    if (typeof d?.ioInsight === 'boolean') {
      return d.ioInsight;
    }
    if (typeof res?.ioInsight === 'boolean') {
      return res.ioInsight;
    }
    return false;
  }

  private shouldIncludeIoInsightNavItem(): boolean {
    if (this.currentRole === RoleID.companyAdmin) {
      return this.isIOInsightEnabledForCompanyAdmin;
    }
    return true;
  }

  checkPortalFeatureRequirements(item, userRole) : boolean {
    let isSuperAdmin : boolean = userRole === RoleID.Admin;
    //let isItemAgencyOrEdoc: boolean = (item.name === 'Agencies' || item.name === 'eDoc');
    return isSuperAdmin || this.isEDocPurchased;
  }

  createMenu() {
    let menu: SidenavItem[] = [{
      name: 'Admin Dashboard',
      position: 1,
      routeOrFunction: '/dashboard',
      icon: 'dashboard-icon',
      customClass: 'gc-nav-icon gc-nav-icon-admin-dashboard',
      allowedRoleIds: OnlyIOHSuperAdminAllowedRoles,
      permissionCheck: true
    }];

    if (this.shouldIncludeIoInsightNavItem()) {
      menu.push({
        name: 'ioInsights',
        position: 1,
        routeOrFunction: '/io-insight',
        icon: 'dashboard-icon',
        customClass: 'gc-nav-icon gc-nav-icon-admin-dashboard',
        allowedRoleIds: OnlyAdminAndCompanyAdminAllowedRoles,
        permissionCheck: true
      });
    }

    const episodesManagement: SidenavItem = {
      name: 'Episodes',
      position: 1,
      routeOrFunction: '/episodes',
      icon: 'episode-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyClinicianAllowedRoles,
      permissionCheck: true
    }
    menu.push(episodesManagement);

    const visitsManagement: SidenavItem = {
      name: 'Visits',
      position: 2,
      routeOrFunction: '/visits',
      icon: 'error-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyClinicianAllowedRoles,
      permissionCheck: true
    }
    menu.push(visitsManagement);

    const patientManagement: SidenavItem = {
      name: 'Patients',
      position: 3,
      routeOrFunction: '/p-visits',
      icon: 'Patient-Icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyClinicianAllowedRoles,
      permissionCheck: true
    }
    menu.push(patientManagement);

    const userManagement: SidenavItem = {
      name: 'io Team',
      position: 9,
      routeOrFunction: '/ioh-users',
      icon: 'io-users-icon-green',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlySuperAdminAllowedRoles,
      permissionCheck: true
    }
    menu.push(userManagement);

    const companyManagement: SidenavItem = {
      name: 'Companies',
      position: 6,
      routeOrFunction: '/companies',
      icon: 'company-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlySuperAdminAllowedRoles,
      permissionCheck: true
    }
    menu.push(companyManagement);

    const nonIohUserManagement: SidenavItem = {
      name: 'Users',
      position: 4,
      routeOrFunction: '/users',
      icon: 'Agency-Management',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyAdminAllowedRoles,
      permissionCheck: true
    }
    menu.push(nonIohUserManagement);

    const agentManagement: SidenavItem = {
      name: 'Agencies',
      position: 5,
      routeOrFunction: '/agencies',
      icon: 'agency-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyAdminAllowedRoles,
      permissionCheck: true
    }
    menu.push(agentManagement);

    const esocManagement: SidenavItem = {
      name: 'ioDoc',
      position: 7,
      routeOrFunction: '/e-docs',
      icon: 'soc-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: superAndCaseMangerRoles,
      permissionCheck: true,
      tooltip: 'ioDoc allows agencies to send important patient documents electronically via email or text. This includes Patient Handbooks, Patient Information Reports (PIR), and other patient-facing documents without needing to print or mail physical copies.'
    }
    if(this.isEDocPurchased){
      this.addFeatureItemsToMenu(menu,esocManagement)
    }

    // IOHB-NA: Quality Assurance menu item. Visible only when the current
    // agency's portalFeatures map has qaScrubberEnabled === true. Mirrors the
    // exact gating pattern used for IO Doc (isEDocPurchased) above.
    const qaScrubberManagement: SidenavItem = {
      name: 'ioIQ',
      position: 8,
      routeOrFunction: '/quality-assurance',
      icon: 'quality-assurance-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyAdminAllowedRoles,
      permissionCheck: true,
      tooltip: 'ioIQ — review the rules-engine verdict (validations, suggestions, financials) for each captured submission. Powered by the v2 rule engine.'
    }
    if (this.isQaScrubberEnabled ) {
      this.addFeatureItemsToMenu(menu, qaScrubberManagement);
    }

    // ioIQ v4.1 menu item. Gated by its own portal-feature flag, qaScrubberV4Enabled
    // (since c57a484b), not by the ioIQ item's qaScrubberEnabled above.
    const qaScrubberV4Management: SidenavItem = {
      name: 'ioIQ v4.1',
      position: 8,
      routeOrFunction: '/quality-assurance-v4',
      icon: 'quality-assurance-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyAdminAllowedRoles,
      permissionCheck: true,
      tooltip: 'ioIQ v4.1 — review the rules-engine verdict (validations, suggestions, financials) for each captured submission.'
    }
    if (this.isQAScrubberV4Enabled) {
      this.addFeatureItemsToMenu(menu, qaScrubberV4Management);
    }

    const formDataManagement: SidenavItem = {
      name: 'Form Data',
      position: 9,
      routeOrFunction: '/form-data',
      icon: 'form-data-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyAdminAllowedRoles,
      permissionCheck: true
    }
    menu.push(formDataManagement);

    const medicationAlertsManagement: SidenavItem = {
      name: 'Medication Alerts',
      position: 10,
      routeOrFunction: '/ioh-medication-alerts',
      icon: 'medication-alert-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyAdminAllowedRoles,
      permissionCheck: true,
    };
    menu.push(medicationAlertsManagement);

    // IOHB-1737 — edit the configs the mobile app fetches at runtime, so they
    // can change without releasing a new APK. allowedRoleIds must stay
    // identical to `data.roles` on the 'app-config' route in
    // dashboard-routing.module.ts.
    const appConfigManagement: SidenavItem = {
      name: 'App Configuration',
      position: 11,
      routeOrFunction: '/app-config',
      icon: 'setting-icon-white',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlySuperAdminAllowedRoles,
      permissionCheck: true,
      tooltip:
        'Edit the settings the mobile app downloads at runtime. Changes reach clinician devices on their next sync — no app release needed.',
    };
    menu.push(appConfigManagement);

    const aiComposerManagement: SidenavItem = {
      name: 'AI Composer',
      position: 10,
      routeOrFunction: '/ai-composer',
      icon: 'ai-composer-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyAdminAndCompanyAdminAllowedRoles,
      permissionCheck: true,
    };
    menu.push(aiComposerManagement);

    const appLinkManagement: SidenavItem = {
      name: 'App Link',
      position: 10,
      routeOrFunction: '/app-link',
      icon: 'upload-nav',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlySuperAdminAllowedRoles,
      permissionCheck: true,
    };
    menu.push(appLinkManagement);

    const layoutManagement: SidenavItem = {
      name: 'Layout',
      position: 10,
      routeOrFunction: '/layout',
      icon: 'layout',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlySuperAdminAllowedRoles,
      permissionCheck: true,
    };
    menu.push(layoutManagement);

    const rulesManagement: SidenavItem = {
      name: 'Rules',
      position: 11,
      routeOrFunction: '/rules',
      icon: 'layout',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlySuperAdminAllowedRoles,
      permissionCheck: true,
    };
    menu.push(rulesManagement);

    const reportManagement: SidenavItem = {
      name: 'Reports',
      position: 12,
      routeOrFunction: '/ioh-reports',
      icon: 'report-icon',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyAdminAllowedRoles,
      permissionCheck: true
    }
    menu.push(reportManagement);

    const supportManagement: SidenavItem = {
      name: 'Support',
      position: 11,
      routeOrFunction: '/support',
      icon: 'support-menu',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlySuperAdminAllowedRoles,
      permissionCheck: true
    }
    menu.push(supportManagement);


    const supportTicketManagement: SidenavItem = {
      name: 'Support',
      position: 12,
      routeOrFunction: '/support-ticket',
      icon: 'support-menu',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlyCaseManagerClinicianAllowedRoles,
      permissionCheck: true
    }
    menu.push(supportTicketManagement);

    const uploadFileManagement: SidenavItem = {
      name: 'Upload File',
      position: 13,
      routeOrFunction: '/upload-file',
      icon: 'upload-nav',
      customClass: 'gc-nav-icon',
      allowedRoleIds: OnlySuperAdminAllowedRoles,
      permissionCheck: true
    }

    if(this.currentUser?.is_super_admin || this.currentUser?.is_IOH_admin)
      menu.push(uploadFileManagement);


    this.subscriptions.push(this.userDataManager.user$.subscribe(user => {
      this.sideNavService.items =[];
      let allowedItems:SidenavItem[] = [];

      menu.forEach(item => {
        if(item.permissionCheck){
          if(item.allowedRoleIds.includes(user.currentUserRole)){
            allowedItems.push(item);
          }
        }else{
          allowedItems.push(item);
        }
      });

      allowedItems.forEach(item => {
        this.sideNavService.addItem(item);
      });

    }));

    // this.subscriptions.push(this.userDataManager.user$.subscribe(user => {
    //   this.subscriptions.push(this.userDataManager.activeAgencyRole$.subscribe((currentRole) => {
    //     try {
    //       let request = {
    //         search: "",
    //         status: '',
    //         agencyLevel: '',
    //         agencyID: currentRole.agency,
    //         pagination: null,
    //         companyId: user.is_company_admin && user.currentUserRole === RoleID.companyAdmin ? user.companyId : null

    //       };
    //       this.subscriptions.push(
    //         this.agencyService.getAgenciesWithSearch(request).subscribe({
    //         next:  res => {

    //         if (res?.success && res.content.data?.length) {
    //           this.isEDocPurchased = res.content.data[0].portalFeatures.eDoc;

    //           //-------------------------old-------------------------------

    //             this.sideNavService.items =[];
    //             let allowedItems:SidenavItem[] = [];

    //             menu.forEach(item => {
    //               if(item.permissionCheck){
    //                 if(item.allowedRoleIds.includes(user.currentUserRole) && this.checkPortalFeatureRequirements(item, user.currentUserRole)){
    //                   allowedItems.push(item);
    //                 }
    //               }else{
    //                 allowedItems.push(item);
    //               }
    //             });

    //             allowedItems.forEach(item => {
    //               this.sideNavService.addItem(item);
    //             });

    //           }
    //         },

    //         complete: ()=>{
    //           if(this.authService.authenticated) {
    //             this.getUserProfile();
    //           }
    //         }
    //     })
    //     )} catch (error) {
    //       console.log('Error caught while fetching agenices : ', error);
    //     }

    //   }));
    // }))


  }

}
